import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import * as Constants from '../../../Helper/constants/constants';
import CustomTab from "../../../Helper/customTabs";
import WithoutImageHeader from "../../../Helper/withoutImageHeader";
import Nurse from "../../Tabs/Nurse_List";
import TaskList from "../../Tabs/TaskList";


const SearchScreen = () => {
    const [currentTab, setCurrentTab] = useState('1');
    const tabs = [
        {
            id: 1,
            tabTitle: 'Doctor',
        },
        {
            id: 2,
            tabTitle: 'Nurse',
        },
        {
            id: 3,
            tabTitle: 'Admin Staff',
        },
        {
            id: 4,
            tabTitle: 'Task',
        },
        {
            id: 5,
            tabTitle: 'Patient',
        }
    ];

    return (
        <div className="search_screen">
            <WithoutImageHeader
                header={Constants.Search}
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Form>
                            <Form.Group className="form-group">
                                <Form.Control
                                    type="text"
                                    placeholder="Robert"
                                />
                                <a href="javascript:;">
                                    <div className="icon">
                                        <FontAwesomeIcon icon={faSearch} />
                                    </div>
                                </a>
                            </Form.Group>
                        </Form>
                    </Col>
                </Row>
            </Container>
            <div className="task_btn_area">
                <CustomTab
                    tabs={tabs}
                    currentTab={currentTab}
                    setCurrentTab={(e) => setCurrentTab(e)}
                />
            </div>
            <div className="search_data_details">
                <h4>Search Result : 3</h4>
            </div>
            <div className="custom_tab_data">
                {parseInt(currentTab) === 2 ? <Nurse /> : null}
                {parseInt(currentTab) === 4 ? <TaskList /> : null}

            </div>
        </div>
    )
}

export default SearchScreen;